
import { Course } from '../types';

export const parallel_parenting: Course = {
  id: "parallel_parenting",
  title: "Parallel Parenting",
  description: "High-conflict strategy. Disengaging to reduce conflict for the children.",
  icon: "🧱",
  totalModules: 11,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/parallel_parenting/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is the primary goal of implementing a parallel parenting strategy?",
        "o": [
            "To increase communication and shared decision-making between parents.",
            "To ensure consistent rules and routines across both households.",
            "To radically reduce the emotional temperature of the parental relationship.",
            "To manage all aspects of child-rearing collaboratively from the outset."
        ],
        "a": 2
    },
    {
        "q": "According to 'The Digital Firewall,' what is the recommended method for all communication between parents?",
        "o": [
            "Direct phone calls and text messages for all matters.",
            "Face-to-face meetings, especially during child handovers.",
            "Approved professional platforms like OurFamilyWizard or AppClose.",
            "Emailing only for critical updates and emergencies."
        ],
        "a": 2
    },
    {
        "q": "Which of the following best describes the 'zero-contact handovers' protocol?",
        "o": [
            "Parents meet briefly at a neutral location to exchange the child and discuss updates.",
            "One parent drops off the child at the other parent's home, avoiding direct interaction.",
            "Children are transported by a third party between homes to ensure no parental contact.",
            "Parents use a neutral territory for drop-off and pick-up, never crossing paths to eliminate direct interaction."
        ],
        "a": 3
    },
    {
        "q": "Under the 'Need to Know' information rule, which detail is considered critical and must be shared?",
        "o": [
            "What the child ate for lunch today.",
            "The child's daily routine at the other parent's home.",
            "Medical emergencies or serious health issues.",
            "Minor details about the child's school activities."
        ],
        "a": 2
    },
    {
        "q": "What is the intended duration and purpose of parallel parenting according to the course material?",
        "o": [
            "It is a permanent solution for families with chronic high conflict.",
            "It is a temporary 1-2 year cooling-off buffer to potentially transition to collaborative co-parenting.",
            "It is a short-term strategy used only for immediate crisis management.",
            "It is a model primarily for parents who have never attempted collaborative co-parenting."
        ],
        "a": 1
    }
]
};
